module.exports = __webpack_public_path__ + "img/selected4-min.d02f8400.png";